import RenderIf from 'components/RenderIf';
import {useTranslation} from "react-i18next";
import { Link } from 'react-router-dom';

import './CirculationCard.css';
import CountDown from './CountDown';

const CirculationCard = ({ data, response }) => {
  const {t} = useTranslation();

  return (
    <div className="circulation-card">
      <div className="circulation-card__image">
        <img src="/media/lucky-13.png" alt="magic-balls" />
        <span className="circulation-card__game-count">
          {data.circulationGames?.length}X
        </span>
      </div>
      <div className="circulation-card__date">
        <span>
          <CountDown targetDate={data.expiredDate} />
        </span>
      </div>
      <div className="circulation-card__caption">
        <div className="circulation-card__informations">
          <RenderIf condition={data.isJackpot}>
            <div className="circulation-card__information">
              <span>{t("JACKPOT_AMOUNT")}</span>
              <span>{response?.jackpotAmount} AZN</span>
            </div>
          </RenderIf>
          <div className="circulation-card__information">
            <span>{t("POOL_AMOUNT")}</span>
            <span
              className={
                !data.possibleSeeTotalAmount
                  ? 'circulation-card__information-blur'
                  : ''
              }
            >
              {response?.poolAmount} AZN
            </span>
          </div>
        </div>
        <div className="circulation-card__buttons">
          <Link to="/bron" className="circulation-card__link">
            {t("BRON_NOW")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CirculationCard;
